import React, { useEffect } from "react";
import StudentTable from "../../../components/Table/StudentTable";
import { useSelector } from "react-redux";
import {
  useGetStudentAssignmentMarkQuery,
  useGetStudentQuizMarkQuery,
} from "../../../features/Student/Leaderboard/leaderboardApi";

const positonTableHeaders = [
  "Rank",
  "Name",
  "Quiz Mark",
  "Assignment Mark",
  "Total",
];
export default function MyPosition() {
  const auth = useSelector((state) => state.auth);
  const leaderboard = useSelector((state) => state.leaderboard);
  const { user } = auth;
  const { data: studentAssignmentMark } =
    useGetStudentAssignmentMarkQuery(user?.id) || {};
  const { data: studentQuizMark } = useGetStudentQuizMarkQuery(user?.id) || {};

  const assignmentMark =
    studentAssignmentMark &&
    studentAssignmentMark.reduce((acc, assignment) => {
      return acc + assignment?.mark;
    }, 0);

  const quizMark =
    studentQuizMark &&
    studentQuizMark.reduce((acc, quiz) => {
      return acc + quiz?.mark;
    }, 0);

  return (
    <>
      <div>
        <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>

        <StudentTable headers={positonTableHeaders}>
          <tr className="border-2 border-cyan">
            <th className="table-td text-center font-bold">
              {leaderboard?.rank}
            </th>
            <th className="table-td text-center font-bold">{user?.name}</th>
            <th className="table-td text-center font-bold">{quizMark}</th>
            <th className="table-td text-center font-bold">{assignmentMark}</th>
            <th className="table-td text-center font-bold">
              {quizMark && assignmentMark && +quizMark + +assignmentMark}
            </th>
          </tr>
        </StudentTable>
      </div>
    </>
  );
}
